// =============================================================
// SCRIPT: AddShoppers Global Pixel Script
// PLACEMENT: End of <body> (Shopify: theme.liquid before </body>)
// SOURCE: Live storefront fetch
// Widget ID: 69450d24bcab067cd49bc88d
// =============================================================

//DO NOT REMOVE - DRIVES REVENUE
var AddShoppersWidgetOptions = { 'loadCss': false, 'pushResponse': false };
(function(){
  var t = document.createElement('script');
  t.type = 'text/javascript';
  t.async = true;
  t.id = 'AddShoppers';
  t.src = 'https://shop.pe/widget/widget_async.js#69450d24bcab067cd49bc88d';
  document.getElementsByTagName('head')[0].appendChild(t);
}());
